document.addEventListener('DOMContentLoaded', () => {
  const settings = JSON.parse(
    document.getElementById('delivery-settings-json').textContent
  );

  const beforeBlock = document.querySelector('[data-before-cutoff]');
  const afterBlock = document.querySelector('[data-after-cutoff]');
  const afterDateSpan = document.querySelector('[data-delivery-after-date]');
  const deliveryDate = document.querySelectorAll('[data-delivery-date]');
  const deliveryDeadline = document.querySelectorAll('[data-delivery-deadline]');

  const now = new Date();
  const today = now;
  const dayIndex = today.getDay();
  const days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
  const currentDay = days[dayIndex];

  const cutOffTime = settings.cutoff[currentDay];
  const beforeText = settings.before[currentDay];
  const afterText = settings.after[currentDay];

  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  function timeToMinutes(t) {
    if (!t) return null;
    const [h, m] = t.split(':');
    return parseInt(h) * 60 + parseInt(m);
  }

  function addTime(date, time) {
    const d = new Date(date);
    const [h, m] = time.split(':');
    d.setHours(h);
    d.setMinutes(m);
    d.setSeconds(0);
    return d;
  }

  function updateBanners() {
    const currentTime = new Date();
    const minutes = currentTime.getHours() * 60 + currentTime.getMinutes();
    const isBeforeCutoff = cutOffTime && minutes < timeToMinutes(cutOffTime);

    document.querySelectorAll('[data-banner-before]').forEach(el => {
      el.hidden = !isBeforeCutoff;
    });
    document.querySelectorAll('[data-banner-after]').forEach(el => {
      el.hidden = !!isBeforeCutoff;
    });
  }

  document.addEventListener('cart:delivery-text-updated', updateBanners);
  updateBanners();

  if (!beforeBlock || !afterBlock || !afterDateSpan) return;

  // === EMPTY CUT-OFF → AFTER-CUTOFF ===
  if (!cutOffTime) {
    beforeBlock.hidden = true;
    afterBlock.hidden = false;
    afterDateSpan.textContent = afterText;

    return;
  }

  const cutOffMinutes = timeToMinutes(cutOffTime);

  // === BEFORE CUT-OFF ===
  if (currentMinutes < cutOffMinutes) {
    beforeBlock.hidden = false;
    afterBlock.hidden = true;

    const countdownTarget = addTime(today, cutOffTime);

    function updateCountdown() {
      const diff = countdownTarget - new Date();

      if (diff <= 0) return;

      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      deliveryDeadline.forEach(el => {
        el.textContent = `${hours}h ${minutes}m ${seconds}s`;
      });
    }

    deliveryDate.forEach(el => el.textContent = beforeText);

    updateCountdown();
    setInterval(updateCountdown, 1000);
    return;
  }

  // === AFTER CUT-OFF ===
  beforeBlock.hidden = true;
  afterBlock.hidden = false;
  afterDateSpan.textContent = afterText;

});
